import { css } from "@emotion/css";
import type React from "react";
import { forwardRef, useLayoutEffect, useState } from "react";
import type { DropdownButtonState } from "../../Dropdown";
import { Popover } from "../../Popover";
interface SelectDropdownProps {
    dropdownButtonState: DropdownButtonState;
    children: React.ReactNode;
    anchorElement?: HTMLElement | null;
}
export const SelectDropdown = forwardRef<HTMLDivElement, SelectDropdownProps>(({ dropdownButtonState, anchorElement, children }, ref) => {
    const [buttonWidth, setButtonWidth] = useState<number | undefined>(undefined);
    const anchor = anchorElement ?? dropdownButtonState.buttonElement;
    useLayoutEffect(() => {
        if (!anchor)
            return;
        const updateWidth = () => {
            setButtonWidth(anchor.offsetWidth);
        };
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(anchor);
        return () => {
            resizeObserver.disconnect();
        };
    }, [anchor]);
    return (<Popover placement={"bottom-start"} anchorEl={anchor} open={dropdownButtonState.isOpen} onClose={dropdownButtonState.closeDropdown} elementId={dropdownButtonState.dropdownAttributes.dropdownId} boundaryPadding={16}>
            <div className={dropdownContainerStyles} style={{ width: buttonWidth }} ref={ref}>
                {children}
            </div>
        </Popover>);
});
SelectDropdown.displayName = "SelectDropdown";
const dropdownContainerStyles = css({
    boxSizing: "border-box",
    maxHeight: "18.75rem",
    display: "flex",
    flexDirection: "column",
});
